/** @jsx jsx */
import React, { useEffect } from 'react';
import { cssMap } from '@compiled/react';
import { jsx } from '@atlaskit/css';
import SectionMessage from '@atlaskit/section-message';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import messages from '../messages.tsx';

const styles = cssMap({
	container: {
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
	},
});

export const InheritancePopupErrorFallback = (): JSX.Element => {
	const intl = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		fireUIAnalytics(
			createAnalyticsEvent({
				action: 'viewed',
				actionSubject: 'inheritancePopup',
			}),

			{ hasError: true },
		);
	}, [createAnalyticsEvent]);

	return (
		<Box xcss={styles.container}>
			<SectionMessage
				appearance="error"
				title={intl.formatMessage(messages.errorLoadingInheritancePopupTitle)}
			>
				{intl.formatMessage(messages.errorLoadingInheritancePopupMessage)}
			</SectionMessage>
		</Box>
	);
};
